<template>
  <div ref="frisbuy-widget-gallery" :class="{'frisbuy-letoile_official':true, 'frisbuy-widget': true, 'frisbuy-vertical': isVerticalGallery, [`frisbuy-layout-${ gallerySettings.layout }`]: gallerySettings.layout, }" :style="[galleryStyle]">
    <!-- <script src="https://connect.facebook.net/en_US/all.js" async="" type="application/javascript" v-if="settings.popup.shareButtons.fb"></script> -->
    <div class="frisbuy-header">
      <div class="frisbuy-title" v-if="headerSettings.title || headerSettings.buttonTitle">
        {{headerSettings.title}}<a v-if="headerSettings.buttonTitle" :href="headerSettings.buttonLink">{{headerSettings.buttonTitle}}</a>
      </div>
      <div v-if="headerSettings.subTitle" class="frisbuy-subtitle" :style="[subTitleStyle]">{{headerSettings.subTitle}}</div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{ 'frisbuy-category': true, 'frisbuy-active': filterValue == filter.value || (filterValue == null && !filter.value) }"
        v-for="filter in gallerySettings.filters.params"
        @click="chosenFilter(filter)">{{filter.name}}</a>
    </div>
    <div class="frisbuy-buttons-list">
      <div class="frisbuy-upload-button" widget-iu-button="true" onclick="iuWidget.open()" style="visibility:hidden; pointer-events: none">
        Загрузи свое фото
        <div class="frisbuy-upload-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.54415 5.36754C8.81638 4.55086 9.58066 4 10.4415 4H13.5585C14.4193 4 15.1836 4.55086 15.4558 5.36754L16 7H19C20.1046 7 21 7.89543 21 9V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V9C3 7.89543 3.89543 7 5 7H8L8.54415 5.36754Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="13" r="4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{ 'frisbuy-scroll-wrapper': true, 'no-scroll-width': !isVerticalGallery && scrollWidth < 0 }"
        :style="{ height: isVerticalGallery && gallerySettings.maxCols && `${ ((containerItemHeight + containerItemMargin) * gallerySettings.maxCols) }px`}"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
        >
        <div :style="{ padding: isLineRowsMode && scrollWidth < 0 && `0 ${ containerItemMargin / 2}px` }">
          <ul
            :class="{ 'frisbuy-gallery-posts': true, 'frisbuy-gallery-multiline': isLineRowsMode, [`frisbuy-scheme-${ gallerySettings.scheme }`]: gallerySettings.layout == 'tile' && gallerySettings.scheme }"
            :style="{ margin: `-${ containerItemMargin / 2}px`, width: `calc(100% + ${ containerItemMargin }px)`, height: !isVerticalGallery && isLineRowsMode && containerRowsHeight }"
          >
            <template v-for="(post, index) in postList">
              <li v-if="gallerySettings.scheme && !isTablet && (index == 5 || !((index - 5) % 9))" class="frisbuy-divider"></li>
              <ad-post v-if="post.frisbuyPost.type === 'advertising'" :style="{width: getPostItemWidth(index), margin: `${ containerItemMargin / 2 }px` }" @open-post="openPost" :settings="settings"></ad-post>
              <post-item
                v-else
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index < 3 ? index : index + 1"
                ref="postImage"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :style="{width: getPostItemWidth(index), margin: `${ containerItemMargin / 2 }px` }"
                :observer="imageObserver"
                @click="clickPostHandler(post, index)"
                >
              </post-item>
            </template>
          </ul>
        </div>
      </div>
      <div v-if="gallerySettings.layout == 'arrow' && ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)" :class="{ 'frisbuy-gallery-navigation': true, 'frisbuy-big': isLineRowsMode }">
        <div :class="{'frisbuy-navigation-button': true, 'frisbuy-navigation-button-disabled': !canPrevScroll}" @click="slideHandler(-1)">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
          </svg>
        </div>
        <span></span>
        <div :class="{'frisbuy-navigation-button': true, 'frisbuy-navigation-button-disabled': !canNextScroll}" @click="slideHandler(1)">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
          </svg>
        </div>
      </div>
    </div>
    <!-- IDK: What's component? -->
    <!-- <iu-instruction></iu-instruction> -->
    <div v-if="gallerySettings.branding" :class="[{'frisbuy-branding': true}, gallerySettings.branding ]">
      Сделано на
      <a :href="settings.brandingLink || ('https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign='+settings.customerCode)" rel="nofollow" target="_blank">
        <img :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`" alt="Frisbuy">
      </a>
    </div>
    <div class="frisbuy-footer">
      <div :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px'}" class="frisbuy-loadmore-button" v-if="gallerySettings.layout == 'tile' && gallerySettings.loadMore.enable && gallerySettings.loadMore.show" @click="loadMoreHandler">{{ gallerySettings.loadMore.text || 'Ещё' }}</div>
      <div v-if="gallerySettings.footer.html" v-html="gallerySettings.footer.html"></div>
      <div v-if='gallerySettings.guideline.html' @click="openGuide()" class="frisbuy-addpopup-btn">
        <img class="frisbuy-addpopup-btn__img" :src="`${envDomain}/images/guideline/b1.png`" alt="Guide button picture 1">
        <img class="frisbuy-addpopup-btn__img" :src="`${envDomain}/images/guideline/b2.png`"  alt="Guide button picture 2">
        <img class="frisbuy-addpopup-btn__img" :src="`${envDomain}/images/guideline/b3.png`"  alt="Guide button picture 3">
        <span class="frisbuy-addpopup-btn__text">
          Как попасть на сайт?
        </span>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="(direction) => selectPost(postList[currentPostIndex + direction], currentPostIndex + direction)"
    @close="() => closePopup()"
  />
</template>

<style scoped src="./gallery.scss" lang="scss"></style>
<style scoped src="../../../gallery/gallery/gallery.scss" lang="scss"></style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import Popup from '../popup/popup.vue';
import AdPost from "../components/ad-post.vue";

export default {
  mixins: [defaultGallery],

  components: { Popup, AdPost },

  data() {
    return {
      isGuidlineOpen: false,
    };
  },

  methods: {
    openPost(index) {
      const { postList, clickPostHandler } = this;

      clickPostHandler(postList[index], index);
    },

    openGuide() {
      if (iuWidget.openGuide) {
        this.sendAnaliticEvent("Open_guide", window.location.href);
        iuWidget.openGuide();
      }
    },
  },
};
</script>